import { createSelector } from '@reduxjs/toolkit';

import { BettingEntitiesSelectors } from 'app/lib/betting/betting-entities';
import { currentLocation } from 'app/modules/Navigation/selectors';

export default (
  tournaments: BettingEntitiesSelectors['tournaments'],
  tournamentUnions: BettingEntitiesSelectors['tournamentUnions'],
  sports: BettingEntitiesSelectors['sports'],
) => {
  return createSelector(
    currentLocation,
    tournaments,
    tournamentUnions,
    sports,
    (
      { tournamentId, tournamentUnionId, sportId },
      tournamentsById,
      unionsById,
      sportsById,
    ) => {
      if (!sportId || !tournamentUnionId || !tournamentId) {
        return [];
      }

      const sport = sportsById.get(sportId);
      const union = tournamentsById.get(tournamentUnionId);
      const tournament = unionsById.get(tournamentId);
      if (!sport || !union || !tournament) {
        return [];
      }

      const entities = [
        sport,
        union,
        tournament,
      ].filter((entity) => entity && entity.name);

      return entities.map((entity) => entity.name);
    },
  );
};
